import React, { useState } from 'react';
import './Consultancy.css';
import PageHeader from '../about/PageHeader';
import Footer from '../components/Footer';
import Navbar from '../components/navbar';

const IgnoVisionPortfolio = () => {
  const [activeFilter, setActiveFilter] = useState('All');

const projects = [
    // ================= ONGOING =================
    {
      id: 1,
      category: 'Web Development',
      title: 'MMA Website',
      status: 'Ongoing',
      desc: 'Website developed for Malad Medical Association (since 1964), one of Mumbai’s largest associations with 2200+ members providing healthcare services.',
      team: ['Dr. Vinita Gaikwad (Director)', 'Ms. Kinjal Doshi'],
      tag: 'Web Apps',
      image: '/RD/MMA.png'
    },
    {
      id: 2,
      category: 'Non-Profit Portal',
      title: 'FOCUS NGO',
      status: 'Ongoing',
      desc: 'NGO platform for child welfare enabling donations and showcasing events and initiatives.',
      team: ['Dr. Vinita Gaikwad', 'Ms. Kinjal Doshi', 'Ms. Anamika Dhawan', 'Ms. Shweta Waghmare'],
      tag: 'Web Apps',
      image: '/RD/focus.png'
    },
    {
      id: 3,
      category: 'Healthcare App',
      title: 'eToken-OPD',
      status: 'Ongoing',
      desc: 'Application for LTMMC Hospital to reduce queues by generating tokens and managing patient time slots.',
      team: ['Dr. Vinita Gaikwad', 'Ms. Monisa Correia'],
      tag: 'Mobile',
      image: '/RD/etokenApp.png'
    },
    {
      id: 4,
      category: 'Agri-Tech',
      title: 'DDMM App',
      status: 'Ongoing',
      desc: 'Helps dairy farmers analyze milk production, track animal health, pregnancy status, and production graphs.',
      team: ['Dr. Vinita Gaikwad', 'Ms. Anamika Dhawan', 'Ms. Kinjal Doshi'],
      tag: 'Mobile',
      image: '/RD/DDMMApp.jpg'
    },
    {
      id: 5,
      category: 'E-Commerce',
      title: 'Farmer Produce App',
      status: 'Ongoing',
      desc: 'Online agriculture marketplace supporting English, Hindi, and Marathi for direct farmer-to-consumer sales.',
      team: ['Dr. Vinita Gaikwad', 'Ms. Shweta Waghmare'],
      tag: 'Mobile',
      image: '/RD/IMG_20221013_121920.jpg'
    },

    // ================= COMPLETED =================
    {
      id: 6,
      category: 'Web Development',
      title: 'Amrut Hospital',
      status: 'Completed',
      desc: 'Hospital website enabling online appointment booking for patients.',
      team: ['Dr. Vinita Gaikwad', 'Mira Gohil', 'Ms. Kinjal Doshi'],
      tag: 'Web Apps',
      image: '/RD/amrut.png'
    },
    {
      id: 7,
      category: 'Mobile Application',
      title: 'DMI App',
      status: 'Completed',
      desc: 'Student health monitoring app with survey tracking and dashboard reporting.',
      team: ['Dr. Vinita Gaikwad', 'Ms. Mira Gohil', 'Ms. Kinjal Doshi'],
      tag: 'Mobile',
      image: '/RD/DMI-project.jpg'
    },
    {
      id: 8,
      category: 'Web Development',
      title: 'APSO Website',
      status: 'Completed',
      desc: 'Dynamic platform for Pediatric Surgeon Oncology association managing conferences and memberships.',
      team: ['Dr. Vinita Gaikwad', 'Ms. Mira Gohil', 'Ms. Kinjal Doshi'],
      tag: 'Web Apps',
      image: '/RD/APSO-project.jpg'
    },
    {
      id: 9,
      category: 'Healthcare App',
      title: 'Indian Carb Counter',
      status: 'Completed',
      desc: 'Nutrition calculation system developed for Nurture Health Solutions.',
      team: ['Dr. Vinita Gaikwad', 'Ms. Mira Gohil'],
      tag: 'Mobile',
      image: '/RD/Indian-carb-counter.jpg'
    },
    {
      id: 10,
      category: 'Healthcare App',
      title: 'Teratology App',
      status: 'Completed',
      desc: 'Application to study medication effects on pregnancy and fetal development.',
      team: ['Dr. Vinita Gaikwad', 'Ms. Mira Gohil'],
      tag: 'Mobile',
      image: '/RD/Teratology.jpg'
    },
    {
      id: 11,
      category: 'Mobile Application',
      title: 'Monsoon Diseases App',
      status: 'Completed',
      desc: 'App for awareness of diseases like Dengue, Malaria, and preventive measures (developed with MCGM).',
      team: ['Dr. Vinita Gaikwad', 'Ms. Mira Gohil'],
      tag: 'Mobile',
      image: '/RD/Mansoon-related-illnesses.jpg'
    },
    {
      id: 12,
      category: 'Mobile Application',
      title: 'Beat Diabetes',
      status: 'Completed',
      desc: 'Healthcare app developed for LTMMC Hospital and released by MCGM.',
      team: ['Dr. Vinita Gaikwad', 'Ms. Mira Gohil'],
      tag: 'Mobile',
      image: '/RD/Beat-Diabetes.jpg'
    },
    {
      id: 13,
      category: 'Mobile Application',
      title: 'Dr. Jacob Diabetic App',
      status: 'Completed',
      desc: 'App and website for advanced diabetic treatment center (in development stage).',
      team: ['Dr. Vinita Gaikwad', 'Ms. Mira Gohil'],
      tag: 'Mobile',
      image: '/RD/Dr.jacobapp.jpg'
    }
  ];

  const filteredProjects =
    activeFilter === 'All'
      ? projects
      : projects.filter(p => p.tag === activeFilter);

  return (
    <>
      <Navbar />

      <PageHeader
        title="Consultancy Cell"
        crumbs={[
          { label: "Home", href: "/" },
          { label: "Consultancy Cell" },
        ]}
      />

      <div className="ivp-container">

        {/* HERO */}
        <header className="ivp-hero">
       

          <p className="ivp-subtitle">
            TIMSCDR offers consultancy services to industries, government bodies, and organizations in areas like feasibility studies,
            product design, process development, software development, and corporate training.
          </p>

          <p className="ivp-subtitle">
            The institute is actively engaged in corporate training, mobile app development, and website solutions for real-world clients.
          </p>

          {/* STATS */}
          <div className="ivp-stats-grid">
            {[
              { label: 'Projects', value: '50+' },
              { label: 'Experts', value: '12' },
              { label: 'Success', value: '100%' },
              { label: 'Years', value: '15+' }
            ].map((stat, i) => (
              <div key={i} className="ivp-stat-card">
                <div className="ivp-stat-value">{stat.value}</div>
                <div className="ivp-stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </header>

        {/* MAIN */}
        <div className="ivp-main-content">

          <div className="ivp-section-header">
            <div>
              <div className="ivp-section-title">Portfolio Projects</div>
              <div className="ivp-underline"></div>
            </div>

            <div className="ivp-filter-bar">
              {['All', 'Web Apps', 'Mobile'].map((filter) => (
                <div
                  key={filter}
                  className={`ivp-filter-btn ${activeFilter === filter ? 'active' : ''}`}
                  onClick={() => setActiveFilter(filter)}
                >
                  {filter === 'All' ? 'All Projects' : filter}
                </div>
              ))}
            </div>
          </div>

          {/* PROJECT GRID */}
          <div className="ivp-project-grid">
            {filteredProjects.map((project) => (
              <div key={project.id} className="ivp-project-card">

                <div className="ivp-image-placeholder">
                  <div className={`ivp-status-badge ${project.status.toLowerCase()}`}>
                    {project.status}
                  </div>

                  <img
                    src={project.image}
                    alt={project.title}
                    className="ivp-project-ss"
                  />
                </div>

                <div className="ivp-card-body">
                  <div className="ivp-category-tag">{project.category}</div>
                  <div className="ivp-card-title">{project.title}</div>
                  <div className="ivp-card-desc">{project.desc}</div>

                  <div className="ivp-team-section">
                    <div className="ivp-team-header">PROJECT TEAM</div>
                    {project.team.map((member, i) => (
                      <div key={i} className="ivp-team-member">{member}</div>
                    ))}
                  </div>
                </div>

              </div>
            ))}
          </div>

        </div>
      </div>

      <Footer />
    </>
  );
};

export default IgnoVisionPortfolio;